<section class="colleague-head">
  <div class="sd-display colleague-text">{{colleague.userInfo.academicTitle}} {{colleague.userInfo.firstName}} {{colleague.userInfo.lastName}}</div>
  <div>
    <ng-content select="[label]"></ng-content>

    @if (editable) {
      <sd-4-5-1-button variant="tertiary" (click)="modifyUser()">
        <sd-4-5-1-icon name="system/pen" library="{{ iconLibrary }}"></sd-4-5-1-icon>
      </sd-4-5-1-button>

      <sd-4-5-1-button variant="tertiary" (click)="deleteUser()">
        <sd-4-5-1-icon name="system/trash" library="{{ iconLibrary }}"></sd-4-5-1-icon>
      </sd-4-5-1-button>
    }
  </div>
</section>

<sd-4-5-1-divider></sd-4-5-1-divider>
<sd-4-5-1-divider></sd-4-5-1-divider>

<section class="colleague-display-info">
  <div class="colleague-text">{{'profile.recertification.email' | transloco}}</div>
  <div class="colleague-text">{{colleague.userInfo.mailAddress}}</div>

  <sd-4-5-1-divider></sd-4-5-1-divider>

  <div class="colleague-text">{{'profile.recertification.admin.label' | transloco}}</div>
  <div class="colleague-text">{{('profile.recertification.admin.' + (colleague.admin ? 'true' : 'false')) | transloco}}</div>
</section>
